/* eslint react-hooks/exhaustive-deps: 0 */
import { useEffect, useState } from 'react';
import {
  Switch, 
  Grid,
  FormControlLabel,
} from '@mui/material';


export const CommitedReceivedField = (props) => {
  const { onChange, original_commited, original_received } = props
  const [ commited, setCommited ] = useState(original_commited === 1 ? true : false)
  const [ received, setReceived ] = useState(original_received ? true : false)

  // useEffect(() => {
  //   setCommited(original_commited)
  //   setReceived(original_received ? true : false)
  // }, [original_commited, original_received])

  useEffect(() => {
    setTimeout(() => {
      if (onChange) {
        onChange([commited, received])
      }
    }, 50);
  }, [commited, received])

  useEffect(() => {
    if (!commited && received) {
      setReceived(false)
    }
  }, [commited])

  useEffect(() => {
    if (!commited && received) {
      setCommited(true)
    }
  }, [received])

  return (
    <Grid container rowSpacing={0} spacing={1}>
      <Grid item xs={12}>
        <FormControlLabel 
          control={
            <Switch 
              checked={commited}
              onChange={(e) => setCommited(e.target.checked)}
            />
          }
          label="Commited" 
          labelPlacement="start"
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel 
          control={
            <Switch 
              checked={received}
              onChange={(e) => setReceived(e.target.checked)}
            />
          }
          label="Received" 
          labelPlacement="start"
        />
      </Grid>
    </Grid>
  )
}